module.exports = __webpack_public_path__ + "static/media/value-proposition.3c755421.png";